<div class="row">
  <div class="col 3">
    <div class="card col p-3 m-3">
        <div class="ui statistic">
            <div class="label">
             <h3>Confirmed</h3>
            </div>
            <div class="value">
             {{totalConfirmed}}
            </div>
          </div>
    </div>
  </div>
  <div class="col 3">
    <div class="card col p-3 m-3">
        <div class="ui statistic">
            <div class="label">
             <h3>Recovered</h3>
            </div>
            <div class="value">
                {{totalRecovered}}
            </div>
          </div>
          </div>
    </div>
    <div class="col 3">
    <div class="card col p-3 m-3">
        <div class="ui statistic">
            <div class="label">
              <h3>Deaths</h3>
            </div>
            <div class="value">
                {{totalDeaths}}
            </div>
          </div>
          </div>
    </div>
    <div class="col 3">
    <div class="card col p-3 m-3">
        <div class="ui statistic">
            <div class="label">
              <h3>Active</h3>
            </div>
            <div class="value">
                {{totalActive}}
            </div>
          </div>
    </div>
  </div>
</div>